import React from "react"
import Modal from "../../Components/Modal/Modal"
import ConfirmButton from "../../Components/Buttons/ConfirmButton"
import CancelButton from "../../Components/Buttons/CancelButton"

class ConfirmationBox extends React.Component {
  // get the class from Helper files
  // should decides if we want to define class in database or just in Helper
  handleClose = () => {
    // console.log(this.props)
    this.props.togglePopup(false)
  }

  handleDelete = () => {
    // ======= Close popup =======
    this.props.togglePopup(true)
  }

  render() {
    return (
      <Modal
        show={true}
        onClose={this.handleClose}
        className="delete-modal"
        header="Delete"
      >
        <div class="row">
          <div class="col-12 mb-5">
            <h5>Are you sure you want to delete it?</h5>
          </div>
        </div>

        <div className="row qualification-footer">
          <div className="col-md-6">
            <CancelButton onClick={this.handleClose}>Cancel</CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton onClick={this.handleDelete}>Delete</ConfirmButton>
          </div>
        </div>
      </Modal>
    )
  }
}

export default ConfirmationBox
